import PaymentDetail from './payment-detail.vue'

export default PaymentDetail
